import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { Box, styled } from "@mui/system";
import { t } from "i18next";
import { ReactNode, SyntheticEvent } from "react"

const DialogButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
}));

type Props = {
  children: ReactNode;
  status: boolean;
  onClose: () => void;
  onClick: () => void;
  translationKey: string;
  disabled: boolean
};

export const DialogAction = ({
  children,
  status,
  onClose,
  onClick,
  translationKey,
  disabled = false
}: Props) => {
  const handleClose = (_: SyntheticEvent<unknown>, reason?: string) => {
    if (reason !== "backdropClick") {
      onClose();
    }
  };

  return (
    <Dialog open={status} onClose={handleClose}>
      <Box>
        <DialogTitle>
          {t(`location_details.${translationKey}.dialog_titel`)}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxWidth: 300,
              width: "50vh",
              rowGap: (t) => t.spacing(2),
            }}
            alignItems="stretch"
          >
            {children}
          </Box>
        </DialogContent>
        <DialogActions>
          <DialogButton onClick={handleClose}>
            {t("location_details.cancel")}
          </DialogButton>
          <DialogButton onClick={onClick} disabled={disabled}>
            {t("location_details.ok")}
          </DialogButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
